import { render, staticRenderFns } from "./singleSummary.vue?vue&type=template&id=3d59b854&scoped=true&"
import script from "./singleSummary.vue?vue&type=script&lang=js&"
export * from "./singleSummary.vue?vue&type=script&lang=js&"
import style0 from "./singleSummary.vue?vue&type=style&index=0&id=3d59b854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d59b854",
  null
  
)

export default component.exports